/*
 * @Description: 结算方式设置
 * @Author: 杨志航
 * @Date: 2026-05-14 09:47:08
 */
import React, { useState, useEffect, useRef } from 'react'
import api from 'api'
import {
  Table,
  Form,
  Input,
  Button,
  Select,
  Alert,
  DatePicker,
  message,
  Modal,
  Icon,
} from 'antd'
import { allTrim, filterParams } from '@/utils'
import Import from '@/components/Import'
import Export from '@/components/Export'

const { Column } = Table
const FormItem = Form.Item
const Option = Select.Option
const typeList = [
  { id: 0, name: '直销'},
  { id: 1, name: '代理商'},
]
const settlementTypeList = [
  { id: 1, name: '消耗结算'},
  { id: 2, name: '充值结算'},
]
const dateFormat = 'YYYY-MM-DD'

let pageSize = 10
let currentPage = 1
let searchParams = {
  limit: pageSize, 
  page: currentPage,
}

const SettlementMethod = props => {
  const { getFieldDecorator, validateFields, resetFields, setFieldsValue, getFieldsValue } = props.form
  const [count, setCount] = useState(0)
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [projectList, setProjectList] = useState([])
  const [productList, setProductList] = useState([])
  const [visibleFile, setVisibleFile] = useState(false)
  const [showExport, setShowExport] = useState(false)
  const [failVisible, setFailVisible] = useState(false)
  const [successVisible, setSuccessVisible] = useState(false)
  const ImportRef = useRef(null)
  const productsRef = useRef(null)

  useEffect(() => {
    api.getsysProjectChilds({ pid: 0 }).then(data => {
      setProjectList(data)
    })
    resetParams()
    getList()
  }, [])

  const resetParams = () => {
    searchParams = {
      limit: pageSize, 
      page: currentPage,
    }
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  //获取列表
  const getList = () => {
    setLoading(true)
    api.getSettlementMethodList(searchParams).then(res => {
      const { list, count } = res
      setList(list)
      setCount(count)
      setLoading(false)
    }).catch(() => { setLoading(false) })
  }

  //重置
  const onReset = () => {
    resetFields()
    currentPage = 1
    resetParams()
    getList()
  }

  //提交
  const formSubmit = evt => {
    evt.preventDefault()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        vals = filterParams(vals)
        if (vals.effectiveDate) {
          vals.effectiveDate = vals.effectiveDate.format(dateFormat)
        }
        currentPage = 1
        resetParams()
        searchParams = {...searchParams, ...vals}
        getList()
      }
    })
  }
  //点击分页
  const onChangeTable = (pagination, filters, sorter) => {
    searchParams.page = currentPage = pagination.current
    searchParams.limit = pageSize = pagination.pageSize
    getList()
  }

  const onChangeProject = id => {
    if (id) {
      api.getsysProjectChilds({ pid: id }).then(data => {
        setProductList(data)
      })
    } else {
      setProductList([])
    }
    setFieldsValue({
      productId: undefined,
    })
  }

  // 判断是否允许导入，只有每月26日至月底才允许导入
  const isImportAllowed = () => {
    const today = new Date()
    const year = today.getFullYear()
    const month = today.getMonth()
    const day = today.getDate()
    const lastDay = new Date(year, month + 1, 0).getDate()
    return day >= 26 && day <= lastDay
  }

  const handleImport = () => {
    setSuccessVisible(true)
    // if (isImportAllowed()) {
    //   setSuccessVisible(true)
    // } else {
    //   setFailVisible(true)
    // }
  }

  const onImportFile = () => {
    setVisibleFile(true)
    setSuccessVisible(false)
    ImportRef.current.onRemoved()
  }

  const doImport = (fileList) => {
    if (fileList.length > 0) {
      if (fileList[0].status !== "removed") {
        api.importSettlementMethod({
          path: fileList[0].url
        }).then(() => {
          message.success('导入成功')
          ImportRef.current.onLoading()
          onReset()
          setVisibleFile(false)
        }).catch(() => {
          ImportRef.current.onLoading()
        })
      } else {
        message.error('请导入模板')
      }
    } else {
      message.error('请导入模板')
    }
  }

  return <>
    <div className="search-doc-wrap">
      <Form onSubmit={formSubmit} {...formItemLayout} style={{ paddingTop: '10px' }}>
        <div className="form-box">
          <FormItem label="客户名称">
            {getFieldDecorator('clientName')(<Input placeholder="请输入客户名称" />)}
          </FormItem>
          <FormItem label="OAID/QID">
            {getFieldDecorator('oaid')(<Input placeholder="请输入OAID/QID" />)}
          </FormItem>
          <FormItem label="原始厂商ID">
            {getFieldDecorator('originalVendorId')(<Input placeholder="请输入原始厂商ID" />)}
          </FormItem>
          <FormItem label="客户类型">
            {getFieldDecorator('type')(<Select 
              placeholder="请选择"
              allowClear
            >
              {
                typeList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="结算方式">
            {getFieldDecorator('settlementType')(<Select 
              placeholder="请选择"
              allowClear
            >
              {
                settlementTypeList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="项目">
            {getFieldDecorator('projectId')(<Select
              placeholder="请选择"
              allowClear
              showSearch
              optionFilterProp="children"
              onChange={onChangeProject}
            >
              {
                projectList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="产品">
            {getFieldDecorator('productId')(<Select 
              placeholder="请选择"
              allowClear
              showSearch
              optionFilterProp="children"
            >
              {
                productList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="生效日期">
            {getFieldDecorator('effectiveDate')(<DatePicker 
              placeholder="请选择" 
              format={dateFormat}
              style={{ width: '100%' }}
            />)}
          </FormItem>
        </div>
        <FormItem className="btns" label=" " colon={false}>
          <Button type="primary" htmlType="submit">查询</Button>
          <Button onClick={onReset}>重置</Button>
        </FormItem>
      </Form>
    </div>
    <div className="line"></div>
    <div>
      <div className="add-wrap">
        <Button type="primary" onClick={handleImport}>结算方式导入</Button>
        <Button type="primary" onClick={() => setShowExport(true)} style={{ marginLeft: 15 }}>数据导出</Button>
      </div>
      <Alert className="corp-count" message={`总计：${count}条数据`} type="info" showIcon />
      <Table
        size="small"
        dataSource={list}
        rowKey={(record, index) => index}
        loading={loading}
        pagination={{
          pageSize,
          total: count,
          current: currentPage,
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
        }}
        onChange={onChangeTable}
        scroll={{ x: 'max-content' }}
      >
        <Column title="序号" dataIndex="id" />
        <Column title="客户名称" dataIndex="clientName" />
        <Column title="OAID/QID" dataIndex="oaid" />
        <Column title="客户类型" dataIndex="clientType" />
        <Column title="项目" dataIndex="projectName" />
        <Column title="产品" dataIndex="productName" />     
        <Column title="端口识别号" dataIndex="portIdentify" />
        <Column 
          title="原始厂商ID" 
          dataIndex="originalVendorId" 
          render={(text, record) => text.split(',').map((item, index) => <div key={index}>{item}</div>)}
        />
        <Column title="结算方式" dataIndex="settlementTypeName" />
        <Column title="生效日期" dataIndex="effectiveDate" />
        <Column title="失效日期" dataIndex="expireDate" />
        <Column title="产品线" dataIndex="productLine" />
        <Column title="返利政策" dataIndex="rebatePolicyTxt" />
        <Column title="服务政策" dataIndex="servicePolicyTxt" />
        <Column title="回款主体" dataIndex="paymentEntity" />
        <Column title="备注" dataIndex="remark" />
        <Column title="设置人" dataIndex="addName" />
        <Column title="导入时间" dataIndex="addTime" />
      </Table>
    </div>
    <Modal
      visible={failVisible}
      onOk={() => setFailVisible(false)}
      onCancel={() => setFailVisible(false)}
      className="settlement-tip-modal"
    >
      <div className="tip-content">
        <Icon type="close-circle" style={{ fontSize: '20px', color: '#f5222d' }} />
        <div className="tip-text">每月26日至月底可以导入客户的结算方式，结算方式的生效日期默认为导入当月的1日，请知悉。</div>
      </div>
    </Modal>
    <Modal
      visible={successVisible}
      onOk={onImportFile}
      onCancel={() => setSuccessVisible(false)}
      className="settlement-tip-modal"
    >
      <div className="tip-content">
        <Icon type="check-circle" style={{ fontSize: '20px', color: '#52c41a' }} />
        <div className="tip-text">客户结算方式的生效日期默认为导入当月的1日，导入成功后系统将对消耗结算并返利政策不为空的客户该产品或厂商ID的有可用消耗的订单<span className="color-red">进行自动退单</span>后并按新的折扣<span className="color-red">进行自动提单</span>，如继续导入请点击确认。</div>
      </div>
    </Modal>
    <Import
      onSearch={doImport}
      visibleFile={visibleFile}
      onCloseImport={() => setVisibleFile(false)}
      ImportTemplate="/api/File/DownTemplate?url=/templates/settlementMethod.xlsx&name=结算方式导入模板"
      ImportRef={ImportRef}
    />
    <Export
      show={showExport}
      onCancel={() => {
        setShowExport(false)
        productsRef.current.changeVal()
      }}
      tplUrl="getSettlementMethodExportTpl"
      fieldsUrl="getSettlementMethodTplItems"
      saveUrl="saveSettlementMethodLevelTpl"
      exportUrl="exportSettlementMethod"
      method="export"
      parame={{ ExportType: 'settlementmethod.export', ...searchParams }}
      cRef={productsRef}
      disableDataRange={true}
    />
  </>
}

export default Form.create()(SettlementMethod)
